import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Pagination } from 'ui/components';
import SortingOptions from 'utils/domain/SortingOptions';

import './DataTable.scss';

export default class DataTable extends Component {
	static propTypes = {
		columns: PropTypes.arrayOf(
			PropTypes.shape({
				prop: PropTypes.string.isRequired,
				title: PropTypes.object.isRequired,
				align: PropTypes.oneOf(['left', 'center', 'right']),
				render: PropTypes.func,
				sortable: PropTypes.bool,
				propToSort: PropTypes.string,
				noWrap: PropTypes.bool,
			})
		).isRequired,
		rows: PropTypes.any.isRequired,
		order: PropTypes.shape({
			orderBy: PropTypes.string,
			orderDir: PropTypes.string,
		}),
		onOrderChange: PropTypes.func,
		pagination: PropTypes.shape({
			page: PropTypes.number,
			size: PropTypes.number,
		}),
		onPaginationChange: PropTypes.func,
		count: PropTypes.number,
		id: PropTypes.string,
		hasFooter: PropTypes.bool,
		hasStickyHeader: PropTypes.bool,
	};

	static defaultProps = {
		order: new SortingOptions(),
		onOrderChange: null,
		pagination: null,
		onPaginationChange: null,
		count: 0,
		hasFooter: false,
		id: '',
		hasStickyHeader: false,
	};

	setSort(prop, propToSort) {
		if (!this.isColumnSortable(prop)) {
			return false;
		}

		const colToSortBy = propToSort ? propToSort : prop;

		let { orderBy, orderDir } = this.props.order;

		if (colToSortBy === orderBy) {
			orderDir = orderDir === 'asc' ? 'desc' : 'asc';
		} else {
			orderBy = colToSortBy;
			orderDir = 'asc';
		}

		this.props.onOrderChange(new SortingOptions(orderBy, orderDir));
		return true;
	}

	isSortedByColumn(prop, propToSort) {
		return (
			this.isColumnSortable(prop) &&
			(this.props.order.orderBy === prop ||
				this.props.order.orderBy === propToSort)
		);
	}

	isColumnSortable(prop) {
		return this.props.columns.find(item => (item.prop === prop ? item : null))
			.sortable;
	}

	render() {
		const {
			id,
			columns,
			rows,
			order: { orderDir },
			count,
			pagination,
			onPaginationChange,
			hasFooter,
			hasStickyHeader,
		} = this.props;

		return (
			<div
				className={hasStickyHeader ? 'DataTable sticky' : 'DataTable'}
				id={id}
			>
				<div className={hasStickyHeader ? `StickyHeader` : ``}>
					<table className="table table-bordered table-striped">
						<thead>
							<tr>
								{columns.map((column, index) =>
									<th
										className={
											this.isColumnSortable(column.prop)
												? `DataTable-Columns--${index}`
												: `DataTable-Columns--${index} column-unsortable`
										}
										onClick={this.setSort.bind(
											this,
											column.prop,
											column.propToSort
										)}
										key={index}
									>
										{hasStickyHeader
											? <div className="sticky-header-text">
													{column.title}
												</div>
											: <p>
													{column.title}
													{this.isColumnSortable(column.prop) &&
														<span
															className={`${this.isSortedByColumn(
																column.prop,
																column.propToSort
															)
																? `sortArrow active sort-${orderDir}`
																: 'sortArrow'}`}
															aria-hidden="true"
														/>}
												</p>}
									</th>
								)}
							</tr>
						</thead>

						<tbody>
							{rows.map((row, index) =>
								<tr key={index}>
									{columns.map((column, index) =>
										<td
											key={index}
											className={`text-${column.align
												? column.align
												: 'left'} ${column.noWrap ? ' noWrap' : ''}`}
										>
											{column.render ? column.render(row) : row[column.prop]}
										</td>
									)}
								</tr>
							)}
						</tbody>

						{hasFooter &&
							<tfoot>
								<tr>
									{columns.map((column, index) =>
										<td
											key={index}
											className={`text-${column.align ? column.align : 'left'}`}
										>
											{column.footer ? column.footer : ''}
										</td>
									)}
								</tr>
							</tfoot>}
					</table>
					{pagination &&
						<Pagination
							count={count}
							pagination={pagination}
							onPaginationChange={onPaginationChange}
						/>}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/DataTable/index.js